import { resourceIdentifier } from 'O3_core';

export const SMS_QUEUE_ID = 'sms_queue';
export const SMS_NOTIFICATION_ID = 'sms_notification';

export const SMS_QUEUE_RESOURCE = resourceIdentifier(
  SMS_NOTIFICATION_ID,
  SMS_QUEUE_ID,
);

export const SMS_QUEUE_SCOPES = {
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  filter: 'Filter',
  get: 'Get',
  sideMenuItem: 'SideMenuItem',
};
